import $ from 'jquery';

/**
 * `$.fn.hpanel` — the horizontal marquee behind the footer panels and the
 * in-page pair of the properties index (see features/marqueePanels.js).
 *
 * Moved from the old single-file bundle, minus what nothing called: the
 * `switchOff` / `pause` / `resume` jQuery methods and the `hover`, `focus`,
 * `fixed_class` and `stop` options (with their `mouseSetUp` / `focusSetUp`
 * helpers and the "sibling class container" check). The callers pass only
 * `duration` and `direction`.
 *
 * Options: `duration`, `padding`, `direction`, `marquee_class`, `content_class`.
 */
(function ($) {
    var settings = {};
    var defaults = {
        duration: 1,
        padding: 0,
        marquee_class: '.marquee',
        content_class: '.content',
        direction: 'left',
    };

    $.fn.hpanel = function (options) {
        if (!this.length && !this[0]) return this;
        var el = this[0];

        if (!el.id) {
            el.id = 'hpanel-' + Math.random().toString(36).slice(2);
        }

        var id = el.id;

        if (!settings[id]) {
            settings[id] = $.extend({}, defaults, options);
        } else {
            $.extend(settings[id], options);
        }

        if (checkErrors(this, id)) { return; }
        initSettings(id);

        var newElem = newElement(id);
        elementPush(newElem, id);
        settings[id].current += 1;

        manager(newElem, id);

        // Pause while the tab is in the background, so the marquee does not
        // develop gaps while its timers are throttled.
        window.addEventListener('blur', () => pause(id));
        window.addEventListener('focus', () => resume(id));
    };

    function pause(id) {
        var elems = getAllElements(id);
        elems.queue();
        elems.stop();
    }

    function resume(id) {
        var elems = getAllElements(id);
        elems.each(function (index, el) {
            manager($(el), id);
        });
    }

    function checkErrors(obj, id) {
        try {
            if (obj[0] === undefined || obj.length === 0 || obj.length > 1) {
                throw new Error('FATAL: Selected element must be a single element');
            } else {
                // Getting JQuery selector
                settings[id].container_class = '#' + obj[0].id + obj[0].className;
            }
            if ($(settings[id].container_class + ' ' + settings[id].marquee_class).length !== 1) {
                throw new Error('FATAL: marquee class empty or not valid');
            }
            if ($(settings[id].container_class + ' ' + settings[id].content_class).length !== 1) {
                throw new Error('FATAL: marquee content class empty or not valid');
            }
        } catch (e) {
            console.error(e.message);
            return true;
        }
        return false;
    }

    function initSettings(id) {
        // Setting classes
        settings[id].marquee_class = settings[id].container_class + ' ' + settings[id].marquee_class;
        settings[id].content_class = settings[id].container_class + ' ' + settings[id].content_class;

        // Getting elements width
        settings[id].containerWidth = $(settings[id].container_class).width();

        // Getting content
        settings[id].elements = {};
        settings[id].elements.item = [];
        settings[id].elements.num = $(settings[id].content_class + ' li').length;
        var items = $(settings[id].content_class + ' li').get();
        var maxWidth = 0;
        $(items).each(function (index, item) {
            var content = $(item).html();
            var width = $(item).width();
            maxWidth = (maxWidth < width) ? width : maxWidth;
            settings[id].elements.item.push({ 'content': content, 'width': width });
        });
        settings[id].current = 1;
        settings[id].endPoint = -maxWidth - settings[id].padding;
        $(settings[id].content_class + ' li').remove();

        // Calculating velocity
        settings[id].velocity = ((settings[id].containerWidth + Math.abs(settings[id].endPoint)) / settings[id].duration) * 5;
    }

    function newElement(id) {
        var content = settings[id].elements.item[settings[id].current - 1].content;
        var newElem = $('<li class="marquee-item">' + content + '</li>');
        var startPos = settings[id].containerWidth;
        newElem.css(settings[id].direction, startPos + 'px');

        return newElem;
    }

    function elementPush(elem, id) {
        $(settings[id].content_class).append(elem);
    }

    function destroyElement(elem) {
        $(elem).remove();
    }

    function getLastElement(id) {
        return $(settings[id].marquee_class + ' li:last-child');
    }

    function getAllElements(id) {
        return $(settings[id].marquee_class + ' li');
    }

    function manager(elem, id) {
        var pos = parseInt($(elem).css(settings[id].direction).replace(/[^-\d.]/g, '')) + parseInt(Math.abs(settings[id].endPoint));
        var duration = pos / settings[id].velocity;

        var $animate_direction = {};
        $animate_direction[settings[id].direction] = settings[id].endPoint + 'px';

        elem.animate(
            $animate_direction,
            duration,
            'linear',
            function () {
                destroyElement($(elem));
            }
        );

        checkTime(id);
    }

    function checkTime(id) {
        setTimeout(function () {
            var elem = getLastElement(id);
            var pos = parseInt(elem.css(settings[id].direction)) + parseInt(elem.width());

            if (pos < settings[id].containerWidth) {
                var newElem = newElement(id);
                elementPush(newElem, id);
                manager(newElem, id);
                settings[id].current = (settings[id].current >= settings[id].elements.num) ? 1 : settings[id].current + 1;
            } else {
                checkTime(id);
            }
        }, 100);
    }
}($));
